export default {
  total_orders: {
    title: 'Comenzi',
    orders: 'Comenzi:',
    sales_volume: 'Volum vânzări:',
    delivery_costs: 'Costuri livrare:',
  },
  cash_orders: {
    title: 'Plată în numerar / la ușă',
    orders: 'Comenzi:',
    sales_volume: 'Volum vânzări:',
    delivery_costs: 'Costuri livrare:',
  },
  online_orders: {
    title: 'Plăți online',
    orders: 'Comenzi:',
    sales_volume: 'Volum vânzări:',
    delivery_costs: 'Costuri livrare:',
  },
  total: 'Total',
  collected_taxes_list: {
    title: {
      online: 'Plată online',
      cash: 'Plată numerar',
    },
    table: {
      products_breakdown: {
        fields: {
          product: 'Produs',
          quantity: 'Cantitate',
          total: 'Total',
        },
        labels: {
          total_refunded: 'Rambursat',
        },
      },
      tax_breakdown: {
        fields: {
          tax_percentage: 'TVA %',
          product_type: 'Tip',
          netto: 'Net',
          tax: 'Taxă',
          brutto: 'Total',
        },
        product_types: {
          product: 'Produse {{percentage}}%',
          order_method_fee: 'Taxe livrare {{percentage}}%',
          customer_service_fee: 'Suprataxă online',
        },
      },
    },
  },
};
